<template>
  <div id="app">
    <component :is="this.headerOption.header"></component>
    <div style="min-height: 100vh;">
      <router-view />
    </div>
    <div
      v-if="
        $store.getters.getAuthData.data &&
          $store.getters.getAuthData.data.mhs_jalur
      "
      style="z-index: 10000"
    >
      <my-chat />
    </div>
    <my-footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import EmptyHeader from "@/components/EmptyHeader";
import Footer from "@/components/Footer";
import Chat from "./page/chat/Chat";

export default {
  name: "app",
  components: {
    "my-header": Header,
    "my-footer": Footer,
    "my-chat": Chat,
    "empty-header": EmptyHeader
  },
  created() {
    this.initConversation();
  },
  methods: {
    initConversation() {
      setInterval(() => {
        if (
          this.$store.getters.getAuthData.data &&
          this.$store.getters.getAuthData.data.mhs_jalur
        ) {
          this.$store.dispatch(
            "getConversation",
            this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
          );
        }
      }, 30000);
    }
  },
  computed: {
    headerOption() {
      return this.$store.getters.chatData.openChat
        ? {
            header: EmptyHeader
          }
        : {
            header: Header
          };
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue